import { ChatAPI } from '../api'
import { ApisauceInstance } from 'apisauce'
import { ChatPackageConstructorOptions } from '../index'
import { CodeleapQueryClient } from '@codeleap/query'
import { ChatQueries } from '../queries'

type ConstructorParams = ChatPackageConstructorOptions & {
  chatApi: ChatAPI
  // `ChatQueries` itself extends `BaseChatPackage`, so when the package is
  // bootstrapped in `packages/chat/src/index.ts` the `Queries` instance is
  // constructed BEFORE the queries field can be assigned (`Hooks` and
  // `Services` receive it on construction, but `Queries` cannot receive
  // itself). Modelled as optional + read via `?.queries` at the few call
  // sites that need it.
  queries?: ChatQueries
}
export class BaseChatPackage {
  protected chatApi: ChatAPI
  protected queries?: ChatQueries
  protected api: ApisauceInstance
  protected queryClient: CodeleapQueryClient
  protected getChatClient: ConstructorParams['getChatClient']

  constructor(props: ConstructorParams) {
    this.api = props.api
    this.getChatClient = props.getChatClient
    this.chatApi = props.chatApi
    this.queries = props.queries
    this.queryClient = props.queryClient
  }

  protected bindMethods(service: any) {
    let proto = Object.getPrototypeOf(service)
    
    while (proto && proto !== Object.prototype && proto !== BaseChatPackage.prototype) {
      Object.getOwnPropertyNames(proto).forEach(name => {
        if (name !== 'constructor' && 
            typeof service[name] === 'function' &&
            !(this as any)[name]) { 
          ;(this as any)[name] = service[name].bind(service)
        }
      })
      proto = Object.getPrototypeOf(proto)
    }
  }

  protected bindProperties(instance: any) {
    const instancePropertyNames = Object.getOwnPropertyNames(instance)
    
    for (const name of instancePropertyNames) {
      if (!this.hasOwnProperty(name) && name !== 'constructor') {
        ;(this as any)[name] = instance[name]
      }
    }
  }
}

